var map = {
	"./service_tag_00.png": 9755,
	"./service_tag_01.png": 8626,
	"./service_tag_02.png": 6809,
	"./service_tag_03.png": 9904,
	"./service_tag_04.png": 2751,
	"./service_tag_05.png": 3734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3190;